import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
// import { APIUtils } from '../../../../utils/apiutils';
// import httpClient from '../../../../services/http';
// import { useLabTestStore } from '../labtest.store';

const TestSearchContext = createContext(null);

const TestSearchProvider = ({ children }) => {
    const [testType, setTestType] = useState(null);
    const [collectionType, setCollectionType] = useState(0); // Making Home collection as the default selection
    const [searchStep, setSearchStep] = useState(0);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [city, setCity] = useState('');
    const [testDate, setTestDate] = useState(new Date());
    const [tests, setTests] = useState([]);
    const [coordinate, setCoordinate] = useState(null);
    // const { updateValidatingCity, updateValidCity } = useLabTestStore();

    // const handleVerification = async (city) => {
    //     // setLoading(true);
    //     updateValidatingCity(true);
    //     try {
    //         const url = `${APIUtils.getAPIEndpoint('user:verify-city')}?city=${city}`;
    //         const res = await httpClient.get(url).then(res => res.data);
    //         if (res.status === 'success') {
    //             // setValid(res.data);
    //             updateValidCity(res.data.hasService);
    //             return res.data.hasService;
    //         }
    //     } catch (e) {
    //         console.log(e);
    //         // setError(e);
    //         updateValidCity(false);
    //         return false;
    //     } finally {
    //         updateValidatingCity(false);
    //         // setLoading(false);
    //     }
    // };

    const providerData = {
        testType, setTestType, searchStep, setSearchStep, collectionType, setCollectionType,
        selectedLocation, setSelectedLocation, tests, setTests, testDate, setTestDate, coordinate, setCoordinate,
        city, setCity
    };

    return (
        <TestSearchContext.Provider value={{...providerData}}>
            {children}
        </TestSearchContext.Provider>
    );
};

export const useTestSearchContext = () => {
  const context = useContext(TestSearchContext);
  if (!context) {
    throw new Error('useAppointmentDetailsContext must be used within TestSearchProvider');
  }
  return context;
};

export default TestSearchProvider;

TestSearchProvider.propTypes = {
    children: PropTypes.node.isRequired
};